import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const API_PREFIX = 'https://rhinoapi.thevoicebusiness.com.au';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_PREFIX}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok && data.uuid) {
        localStorage.setItem('uuid', data.uuid);
        navigate('/verify');
      } else {
        setError(data.message || 'Failed to send OTP');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container min-vh-100 d-flex align-items-center justify-content-center bg-glass-bg">
      <div className="glass-card p-4 shadow-lg w-100" style={{maxWidth: 400}}>
        <h2 className="mb-4 text-center fw-bold">Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="email"
              className="form-control form-control-lg"
              placeholder="Email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100 btn-lg mb-2" disabled={loading}>
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
          {error && <div className="alert alert-danger mt-2 py-2 text-center">{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default LoginPage; 